import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShareButtons } from "@/components/site/ShareButtons";
import { CommentSection } from "@/components/site/CommentSection";
import { ArrowLeft } from "lucide-react";

export default function VideoDetail() {
  const { id } = useParams();
  const [v, setV] = useState(null);
  useEffect(() => { api.get(`/videos/${id}`).then(r => setV(r.data)).catch(() => setV(null)); }, [id]);
  if (!v) return <div className="max-w-3xl mx-auto px-4 py-32 text-[#A0AABF]">Se încarcă...</div>;

  return (
    <div data-testid="page-video-detail" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
      <Link to="/video" className="inline-flex items-center gap-2 text-[#D4A63D] text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Înapoi la Video</Link>
      <span className="inline-block text-[10px] uppercase tracking-[0.3em] text-[#D4A63D] bg-[#0A1020]/85 px-3 py-1 border border-[#D4A63D]/30 mb-4">{v.category} · {v.video_type}</span>
      <h1 className="font-display text-3xl md:text-5xl text-[#F8F8F4] leading-tight mb-6">{v.title}</h1>

      <div className="cinematic-card rounded-lg overflow-hidden aspect-video mb-8">
        {v.video_type === "youtube" ? (
          <iframe src={v.embed_url} title={v.title} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
        ) : (
          <iframe src={v.embed_url} title={v.title} className="w-full h-full" allow="accelerometer; encrypted-media;" />
        )}
      </div>

      <div className="flex items-center justify-between flex-wrap gap-4 mb-6">
        <div className="text-sm text-[#A0AABF]">{v.views_count?.toLocaleString("ro-RO")} vizualizări · {v.likes_count} aprecieri</div>
        <ShareButtons title={v.title} compact />
      </div>

      <p className="text-[#F8F8F4]/90 text-lg leading-relaxed whitespace-pre-line">{v.description}</p>

      <CommentSection targetType="video" targetId={v.video_id} />
    </div>
  );
}
